import React, { useEffect, useRef } from "react";
import { useNavigate, NavigateFunction } from "react-router-dom";
import { Grid } from "@mui/material";
import { useMutation } from "@apollo/client";
import { LoadingSpinner } from "components/graphql-views";
import { VERIFY_EMAIL } from "components/login/query";
import { useSnackbar } from "components/haven-design/snackbar";

const redirectTo = (
  navigate: NavigateFunction,
  target: string | null | undefined,
  fallbackPath: string,
) => {
  if (!target) {
    navigate(fallbackPath);
    return;
  }
  if ((/^https?:\/\//i).test(target)) {
    window.location.assign(target);
  } else {
    navigate(target);
  }
};

const VerifyEmail: React.FC = () => {
  const navigate = useNavigate();
  const [verifyEmail] = useMutation(VERIFY_EMAIL);
  const hasAttemptedVerification = useRef(false);
  const { openSnackbar } = useSnackbar();

  useEffect(() => {
    if (hasAttemptedVerification.current) return;
    hasAttemptedVerification.current = true;

    const params = new URLSearchParams(window.location.search);
    const email = params.get("email");
    const code = params.get("code");
    const redirect = params.get("redirect") ?? "";

    if (email && code) {
      verifyEmail({ variables: { email, code } }).finally(() => {
        const payload = {
          message: "Your email address is now verified.",
          status: "success",
          duration: 3000,
        } as const;
        try {
          sessionStorage.setItem("global.snackbar", JSON.stringify(payload));
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn("Could not persist snackbar payload", error);
        }
        openSnackbar(payload);
        redirectTo(navigate, redirect || `/email-verified?u=${encodeURIComponent(email ?? "")}`, "/login");
      });
    } else {
      redirectTo(navigate, redirect, "/login");
    }
  }, [verifyEmail]);

  return (
    <Grid container justifyContent="center" spacing={2} direction="row">
      <LoadingSpinner />
    </Grid>
  );
};

export default VerifyEmail;
